// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { getType } from 'typesafe-actions';

import { CartItem } from '../../types/Cart';
import { RootAction, actionCreatorsList } from '../rootActionCreator';

interface InitState {
  cartItems: CartItem[];
  isLoading: boolean;
}

const { getCartActions } = actionCreatorsList;
export const initialState: InitState = {
  cartItems: [],
  isLoading: false
};

export default function (state = initialState, action: RootAction) {
  switch (action.type) {
    case getType(getCartActions.request): {
      return {
        ...state,
        isLoading: true,
        error: undefined,
      };
    }
    case getType(getCartActions.success): {
      return {
        ...state,
        isLoading: false,
        cartItems: action.payload.cartItems
      };
    }
    case getType(getCartActions.failure): {
      return {
        ...state,
        isLoading: false
      };
    }
  }
  return state;
}
